// Play shell (gameplay 2027): the station countdown (.c-control__countdown) and
// the global teamchallenge countdown (.c-sidebar__countdown) are pinned below the
// header like the stats bar (_station.scss). Their height varies (description,
// wrapped "time is up" text), so this keeps a height variable per bar on <body>
// in sync with it; the play content reserves that much space at the top.

interface PinnedBar {
	selector: string;
	variable: string;
	observed: Element | null;
	resizeObserver: ResizeObserver;
}

function pinnedBar(selector: string, variable: string): PinnedBar {
	return {
		selector,
		variable,
		observed: null,
		resizeObserver: new ResizeObserver(([entry]) => {
			const height = entry.target.getBoundingClientRect().height;
			document.body.style.setProperty(variable, `${Math.ceil(height)}px`);
		}),
	};
}

const BARS: PinnedBar[] = [
	pinnedBar('.c-play .c-control--play .c-control__countdown', '--tc-play-countdown-height'),
	pinnedBar('.c-sidebar__countdown', '--tc-play-global-countdown-height'),
];

// Blazor adds and removes the bars while the station changes steps
function sync(): void {
	for (const entry of BARS) {
		const bar = document.querySelector(entry.selector);
		if (bar === entry.observed) {
			continue;
		}

		if (entry.observed) {
			entry.resizeObserver.unobserve(entry.observed);
		}

		entry.observed = bar;
		if (bar) {
			entry.resizeObserver.observe(bar);
		} else {
			document.body.style.removeProperty(entry.variable);
		}
	}
}

function start(): void {
	new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
	sync();
}

export function initPlayCountdown(): void {
	if (document.body) {
		start();
	} else {
		document.addEventListener('DOMContentLoaded', start);
	}
}
